import * as React from "react";
import {Actions, ManageableQuickscanData} from "../types";
import {QuickscanDataContext} from "../context/QuickscanDataContext";

export const StepFour = () => {

    const [quickscanDataState, quickscanDataDispatch] = React.useContext<ManageableQuickscanData>(QuickscanDataContext);

    React.useEffect(() => {
        quickscanDataDispatch({
            type: Actions.QuickscanDataTypes
                .VALIDATE_QUICKSCAN_STEP,
            payload: {
                step: quickscanDataState.currentStep,
            },
        });
    }, []);

    return <div className={'c-quickscan__form-group'}>
        <p>Om de aanvraag goed te kunnen beoordelen, vragen wij je in een later stadium om een cashflowprognose aan te leveren. Als je
            eerst een geheimhoudingsverklaring van ons wilt ontvangen, kun je dat hier aangeven.</p>
        <div className={'c-form__row'}>
            <div className={'c-quickscan__form-field--full c-quickscan__form-field c-quickscan__form-field__checkbox'}>
                <input type="checkbox" id="field-nda" name="nda"
                       className=" c-form__field c-form__field--full c-form__input-checkbox"
                       checked={quickscanDataState.quickscan.nda}
                       onChange={(e) => {
                           quickscanDataDispatch({
                               type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                               payload: {
                                   quickscan: {
                                       ...quickscanDataState.quickscan,
                                       nda: e.target.checked
                                   }
                               }
                           })
                       }}/>
                <label htmlFor="field-nda" className="c-form__label c-form__label--check">ik ontvang graag een
                    geheimhoudingsverklaring</label>
            </div>
        </div>
        <div className={'c-form__row'}>
        <div className={'c-quickscan__form-field--full c-quickscan__form-field'}>
            <label htmlFor="field-questions" className="c-form__label">Heb je nog specifieke vragen of
                aandachtspunten? </label>
            <textarea id="field-questions" name="questions"
                      className=" c-form__field c-form__field--full c-form__input-text c-form__textarea"
                      defaultValue={quickscanDataState.quickscan.questions}
                      onChange={(e) => {
                          quickscanDataDispatch({
                              type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                              payload: {
                                  quickscan: {
                                      ...quickscanDataState.quickscan,
                                      questions: e.target.value
                                  }
                              }
                          })
                      }}></textarea>
        </div>
        </div>
        <div className={'c-form__row'}>
        <div
            className={`c-quickscan__form-field--full c-quickscan__form-field c-quickscan__form-field__checkbox ${quickscanDataState.validation.fields.privacy ? '' : 'c-form__field--invalid'}`}>
            <input type="checkbox" id="field-privacy" name="privacy"
                   className={'c-form__field c-form__field--full c-form__input-checkbox'}
                   checked={quickscanDataState.quickscan.privacy}
                   onChange={(e) => {
                       quickscanDataDispatch({
                           type: Actions.QuickscanDataTypes.SET_QUICKSCAN_DATA,
                           payload: {
                               quickscan: {
                                   ...quickscanDataState.quickscan,
                                   privacy: e.target.checked
                               }
                           }
                       });
                       quickscanDataDispatch({
                           type: Actions.QuickscanDataTypes
                               .VALIDATE_QUICKSCAN_STEP,
                           payload: {
                               step: quickscanDataState.currentStep,
                           },
                       });
                   }}/>
            <label htmlFor="field-privacy" className="c-form__label c-form__label--check">ik ga akkoord met de <a href={'/privacy'} target={'_blank'}>privacyvoorwaarden</a> van deze
                website</label>
        </div>
        </div>
    </div>;

}
